// TodoPack — Fix min y step en producto y carrito (sin MutationObserver)
(function() {
  function fixProductInput() {
    var input = document.querySelector('quantity-input input[name="quantity"]');
    if (!input) return;

    var min  = parseInt(input.getAttribute('data-min-qty')  || input.getAttribute('min'),  10) || 1;
    var step = parseInt(input.getAttribute('data-step-qty') || input.getAttribute('step'), 10) || 1;

    if (min > 1)  input.setAttribute('min', min);
    if (step > 1) input.setAttribute('step', step);
    if (parseInt(input.value, 10) < min) input.value = min;
  }

  function fixCartInputs() {
    document.querySelectorAll('.cart-item').forEach(function(row) {
      var input = row.querySelector('input.quantity__input');
      if (!input) return;
      var min  = parseInt(input.getAttribute('data-min-qty'), 10) || 1;
      var step = parseInt(input.getAttribute('data-step-qty') || input.getAttribute('step'), 10) || 1;
      if (min > 1)  input.setAttribute('min', min);
      if (step > 1) input.setAttribute('step', step);
      if (parseInt(input.value, 10) < min) input.value = min;
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    [0, 100, 300, 600, 1200, 2000].forEach(function(t) {
      setTimeout(fixProductInput, t);
      setTimeout(fixCartInputs, t);
    });

    document.addEventListener('cart:refresh', fixCartInputs);
    document.body.addEventListener('change', function(e) {
      if (e.target && e.target.closest && e.target.closest('#main-cart-items')) {
        setTimeout(fixCartInputs, 300);
      }
    });
  });
})();